/**
 * Route location for a node of the server-driven main menu (UMNG `/menu/flexigo` or `/menu/main`).
 * A node opens a legacy AngularJS screen when it carries `data.legacyRoute`, which wins over
 * `route`; otherwise it opens the named Vue route, typed by `data.typeParam` (SHUTTLE, VANPOOL,
 * FLEXIRIDE_POOL...) when one route serves several products.
 * @param {{ route?: string, data?: { legacyRoute?: string, typeParam?: string } }} item
 * @returns {{ name: string, params?: object }}
 */
export function menuItemRoute(item) {
  if (item.data?.legacyRoute) {
    return { name: 'legacy', params: { route: item.data.legacyRoute } };
  }
  const route = { name: item.route };
  if (item.data?.typeParam) {
    route.params = { type: item.data.typeParam };
  }
  return route;
}

// Temporary FE gating (VSER-13477): hide Wallet from the menu when walletEnabled is false.
// Remove once the backend omits this node from the menu response.
export const WALLET_MENU_ROUTE = 'MyWallet';

/**
 * Top-level menu nodes the side menu shows.
 * @param {{ children?: object[] }} menu
 * @param {{ walletEnabled?: boolean }} [companySettings]
 * @returns {object[]}
 */
export function visibleMenuItems(menu, companySettings) {
  const children = menu?.children || [];
  if (companySettings?.walletEnabled) return children;
  return children.filter((item) => item.route !== WALLET_MENU_ROUTE);
}

/**
 * Leaf nodes (the ones that open a page) of a menu tree, depth first.
 * @param {{ children?: object[] }} menu
 * @returns {object[]}
 */
export function menuLeaves(menu) {
  return (menu?.children || []).flatMap((item) => (item.children ? menuLeaves(item) : [item]));
}
